import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";
import { Transform, Type } from "class-transformer";
import { toEuros } from "@/utils/numberUtils";
import { CategoryDto } from "@/core/features/categories/category.dto";
import { SubcategoryDto } from "@/core/features/subcategories/subcategory.dto";
import { BrandDto } from "@/core/features/brands/brand.dto";

export class ItemModelDto extends BaseEntityDto {
  name: string;

  @Type(() => BrandDto)
  brand: BrandDto;
  brandId: string;

  externalReference?: string;
  externalCode?: string;

  @Type(() => CategoryDto)
  category: CategoryDto;
  categoryId: string;

  @Type(() => SubcategoryDto)
  subcategory?: SubcategoryDto;
  subcategoryId?: string;

  @Transform(({ value }) => toEuros(value))
  usageCost?: number | null;

  lifespan: number;

  range?: string;

  qrCode?: string;

  toString() {
    if (!this.brand) return this.name;
    return `${this.brand} ${this.name} `;
  }

  get lifespanInDays() {
    return this.lifespan * 30;
  }
}
